export enum MessageStatus {
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}
